import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { buildStoreConfig } from '../storeAliasHelper';

// Standalone "Ultrahuman Ring PRO Charging Case" product
// (handle: ultrahuman-ring-pro-charging-case, SKUs UHRP-CHG-BLK/GLD).
// Deliberately separate from the 0.00 in-box `ultrahuman-ring-pro-charger`
// product that ships attached to every Ring PRO order — never reuse those ids.

type ChargingCaseVariant = {
  variantId: string;
  shopifyVariantId: string;
  checkoutUrl: string;
};

const variant = (
  domain: string,
  id: string,
  suffix = '',
): ChargingCaseVariant => ({
  variantId: id,
  shopifyVariantId: `gid://shopify/ProductVariant/${id}`,
  checkoutUrl: `https://${domain}.myshopify.com/cart/${id}:1${suffix}`,
});

const BlackProdConfig = buildStoreConfig<ChargingCaseVariant>({
  [ShopifyStore.IN]: {
    price: 7_499,
    ...variant('ultrahumanstore', '46436790566982'),
  },
  [ShopifyStore.AE]: {
    price: 369,
    ...variant('ultrahuman-mena', '64275953647987'),
  },
  [ShopifyStore.US]: {
    price: 99,
    ...variant('stelcore-x-ultrahuman', '43074396717152'),
  },
  [ShopifyStore.CA]: { price: 139 },
  [ShopifyStore.ROW]: {
    price: 99,
    ...variant('ultrahuman-us', '46044013822012'),
  },
  [ShopifyStore.EU]: {
    price: 105,
    ...variant('ultrahuman-eu-uk', '58511795126646', '?channel=buy_button'),
  },
  [ShopifyStore.GB]: { price: 89 },
  [ShopifyStore.AU]: { price: 155 },
  [ShopifyStore.SA]: { price: 429 },
  [ShopifyStore.MX]: { price: 2_049 },
  [ShopifyStore.ZA]: { price: 1_899 },
});

const GoldProdConfig = buildStoreConfig<ChargingCaseVariant>({
  [ShopifyStore.IN]: {
    price: 7_499,
    ...variant('ultrahumanstore', '46436790599750'),
  },
  [ShopifyStore.AE]: {
    price: 369,
    ...variant('ultrahuman-mena', '64275953680755'),
  },
  [ShopifyStore.US]: {
    price: 99,
    ...variant('stelcore-x-ultrahuman', '43074396749920'),
  },
  [ShopifyStore.CA]: { price: 139 },
  [ShopifyStore.ROW]: {
    price: 99,
    ...variant('ultrahuman-us', '46044013854780'),
  },
  [ShopifyStore.EU]: {
    price: 105,
    ...variant('ultrahuman-eu-uk', '58511795159414', '?channel=buy_button'),
  },
  [ShopifyStore.GB]: { price: 89 },
  [ShopifyStore.AU]: { price: 155 },
  [ShopifyStore.SA]: { price: 429 },
  [ShopifyStore.MX]: { price: 2_049 },
  [ShopifyStore.ZA]: { price: 1_899 },
});

// STAGING/DEV: same dev variant as TravelChargerStagingConfig on every base
// store so add-to-cart is testable locally.
const stagingVariant = variant('ultrahuman-mena', '40570026983497');
const StagingConfig = buildStoreConfig<ChargingCaseVariant>({
  [ShopifyStore.IN]: { price: 7_499, ...stagingVariant },
  [ShopifyStore.AE]: { price: 369, ...stagingVariant },
  [ShopifyStore.US]: { price: 99, ...stagingVariant },
  [ShopifyStore.CA]: { price: 139 },
  [ShopifyStore.ROW]: { price: 99, ...stagingVariant },
  [ShopifyStore.EU]: { price: 105, ...stagingVariant },
  [ShopifyStore.GB]: { price: 89 },
  [ShopifyStore.AU]: { price: 155 },
  [ShopifyStore.SA]: { price: 429 },
  [ShopifyStore.MX]: { price: 2_049 },
  [ShopifyStore.ZA]: { price: 1_899 },
});

const isProd = process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION';

export const RingProChargingCaseBlackShopifyMap = isProd
  ? BlackProdConfig
  : StagingConfig;

export const RingProChargingCaseGoldShopifyMap = isProd
  ? GoldProdConfig
  : StagingConfig;
